export const STORY_TTL_MS = 24 * 60 * 60 * 1000

const parseStamp = (value) => {
  const raw = String(value || '').trim()
  if (!raw || raw === 'null' || raw === 'undefined') return { file: '', at: 0 }
  const sep = raw.lastIndexOf('|')
  if (sep < 1) return { file: '', at: 0 }
  const at = Number(raw.slice(sep + 1))
  if (!Number.isFinite(at) || at <= 0) return { file: '', at: 0 }
  return { file: raw.slice(0, sep), at }
}

export const encodeStory = (file) => {
  const name = String(file || '').split('|')[0].trim()
  if (!name) return ''
  return `${name}|${Date.now()}`
}

export const storyMsLeft = (story) => {
  const { file, at } = parseStamp(story)
  if (!file || !at) return 0
  return Math.max(0, STORY_TTL_MS - (Date.now() - at))
}

export const hasStory = (story) => storyMsLeft(story) > 0

export const storyFile = (story) => (hasStory(story) ? parseStamp(story).file : '')

export const fetchUserStory = async (userId) => {
  if (!userId) return ''
  const res = await fetch(`/api/auth/auth/${encodeURIComponent(userId)}`)
  if (!res.ok) return ''
  const data = await res.json()
  return data?.msg?.[0]?.story || ''
}
